import React from 'react';
import { useNavigate } from 'react-router-dom';
import PurchaseOrderForm from '../../components/PurchaseOrders/PurchaseOrderForm';
import Toast from '../../components/Common/Toast';
import { useState } from 'react';

const CreatePurchaseOrder = () => {
  const navigate = useNavigate();
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  const handleSuccess = () => {
    setToast({
      isOpen: true,
      message: 'Orden de compra creada exitosamente',
      type: 'success'
    });
    setTimeout(() => {
      navigate('/purchase-orders');
    }, 1500);
  };

  const handleCancel = () => {
    navigate('/purchase-orders');
  };

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Nueva Orden de Compra</h1>
          <p className="text-gray-600 mt-1">Complete el formulario para crear una nueva orden de compra</p>
        </div>

        {/* Formulario */}
        <PurchaseOrderForm
          isOpen={true}
          onClose={handleCancel}
          order={null}
          onSuccess={handleSuccess}
          isPageMode={true}
        />

        {/* Toast de notificaciones */}
        <Toast
          isOpen={toast.isOpen}
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ ...toast, isOpen: false })}
        />
      </div>
    </div>
  );
};

export default CreatePurchaseOrder;






